import { buildProps } from '@bigin/utils'

import type { ExtractPropTypes } from 'vue'

export const menuToggleProps = buildProps({
  collapsed: Boolean,
} as const)
export type MenuToggleProps = ExtractPropTypes<typeof menuToggleProps>
